<template>
  <div class="product-info" v-if="productInfo.valuationList">
    <div class="goods-con" >
      <div class="tbtable" cellspacing="0">
        <ul style="height: 52px;line-height: 52px;">
          <li style="width: 270px;">参赛产品</li><!--
          --><li style="width: 140px;">净值日期</li><!--
          --><li style="width: 140px;">累计净值</li><!--
          --><li style="width: 270px;">本年度已实现收益（单位：元）</li><!--
        --></ul>
        <ul style="height: 52px;" v-for="(item,index) in productInfo.valuationList" :key="index">
          <li :class="{disable:item.existsLjdwjz == true,name:item.existsLjdwjz != true}"><span v-if="productInfo.lhmjPofProduct.isProcedural==1" class="cxh"><img src="../assets/cxh-icon.png"/><a class="cxhjy">程序化交易</a></span>{{productInfo.lhmjPofProduct.productShortName}}</li><!--
          --><li :class="{disable:item.existsLjdwjz == true}">{{item.recordDate}}</li><!--
          --><li><input :class="{disable:item.existsLjdwjz == true}" :disabled="item.existsLjdwjz == true" v-model="item.ljdwjz" @input="item.ljdwjz=item.ljdwjz.replace(/[^\d^\.]+/g,'').replace(/^\./g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')" class="third" /></li><!--
          -->
          <li><input :class="{disable:item.existsLjdwjz == true}" :disabled="item.existsLjdwjz == true" v-model="item.ljyke" @input="item.ljyke=item.ljyke.replace(/[^\d.-]/g,'').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/\-{2,}/g, '-').replace('-', '$#$').replace(/\-/g, '').replace('$#$', '-')" class="forth" /></li>
          <!-- <li><input v-model="item.ljyke" @input="setValue($event.target,index)" class="forth" /></li> -->
        </ul>
      </div>
    </div>
    <div class="email-con">如需修改填报信息，请发邮件联系<span class="email">lhmj@kiiik.com</span>.</div>
    <div class="submit" @click="submitproductInfo">提交</div>
  </div>
  <div class="writeover" v-else>{{productInfo.lhmjPofProduct.productName}}目前已全部填写完毕</div>
</template>
<script>
  import {http} from '../fetch/api'

  export default {
    props: [
      "productInfo"
    ],
    methods: {
      async submitproductInfo() {
        var productInfo = [this.productInfo]
        var newproduct =JSON.parse(JSON.stringify(productInfo))
        var i = newproduct[0].valuationList.length
        while(i--){
          if(newproduct[0].valuationList[i].existsLjdwjz == true){
            newproduct[0].valuationList.splice(i,1)
          }
        }
        var data = await http.jzSubmit(newproduct)
        if(data.code=='0') {
          this.$store.state.noticeMessage="提交成功"
          this.$emit("refreshList")
        }
      },
      // setValue (target,index) {
      //   this.productInfo.valuationList[index].ljyke = target.value.replace(/[^\d.-]/g,'').replace(/\.{2,}/g, '.').replace(/^\./g, "").replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/\-{2,}/g, '-').replace('-', '$#$').replace(/\-/g, '').replace('$#$', '-').replace(/(?<=\d)-$|(?<=\.)-$/g, '')
      // }
    }
  }
</script>
<style scoped>
.product-info {
  width:836px;
  margin: 0 auto;
}
  .tbtable {
    width: 826px;
    font-size: 16px;
    text-align: center;
  }

  .tbtable ul {
    height: 52px;
    line-height: 52px;
    background-image: url("../assets/jztableline.png");
    background-repeat: no-repeat;
    background-size: contain;
  }

  .tbtable ul:nth-child(1) {
    background-image: url("../assets/jztitle.png");
  }

  .tbtable img {
    width: 15px;
    vertical-align: middle;
    margin-right: 10px;
  }

  .tbtable li {
    display: inline-block;
    text-align: center;
    /*border: solid #27a7ea 1px;*/
    /*border-top: none;*/
    /*border-left: none;*/
    color: #0d225c;
  }

  .tbtable li:nth-child(1) {
    width: 270px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: bottom;
    /*border-left: solid #27a7ea 1px;*/
  }
  .tbtable li:nth-child(2) {
    width: 140px;
    /*border-left: solid #27a7ea 1px;*/
  }
  .tbtable li:nth-child(3) {
    width: 140px;
    /*border-left: solid #27a7ea 1px;*/
  }
  .tbtable li:nth-child(4) {
    width: 270px;
    /*border-left: solid #27a7ea 1px;*/
  }

  .goods-con {
    border: 5px solid;
    border-image: url(../assets/jzk.png) 10 stretch;

    max-height:570px;
    overflow: auto;
    box-sizing: border-box;
  }


  /*滚动条整体样式*/
  .goods-con::-webkit-scrollbar {
    width: 8px;
    height: 1px;
  }

  /*滚动条滑块*/
  .goods-con::-webkit-scrollbar-thumb {
    border-radius: 0px;
    -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.1);
    background: #a4f1fc;
  }

  /*滚动条轨道*/
  .goods-con::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0);
    border-radius: 10px;
    background: none;
  }

  .email-con {
    margin-top: 20px;
  }

  .email {
    color: #27a7ea;
    text-decoration: underline;
  }

  .submit {
    width: 220px;
    margin: 0 auto;
    height: 40px;
    line-height: 40px;
    background: #0d225c;
    border-radius: 6px;
    text-align: center;
    color: #fff;
    margin-top: 20px;
  }
  input {
    border: none;
    outline: none;
    background: none;
    padding: 15px;
    box-sizing: border-box;
    margin: 0;
  }
  .third {
    width:140px;
    height: 50px;
    vertical-align: top;
  }
  .forth {
    width:280px;
    height: 50px;
    vertical-align: top;
  }
  .disable {
    color: #C0C4CC !important;
  }
  .writeover {
    font-family: MicrosoftYaHei-Bold;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 32px;
    letter-spacing: 1px;
    color: #0d225c;
  }
  .name {
    font-weight: bold;
  }
.cxh {
  position: relative;
  display: inline-block;
  margin-right: 5px;
  vertical-align: middle;
}
.cxh .cxhjy {
  position: absolute;
  display: none;
  top: 32px;
  left: -40px;
  color: #767676;
  font-size: 14px;
  font-weight: normal;
  width:80px;
  padding: 0 5px;
  border-radius: 3px;
  background: #fff;
  height: 20px;
  line-height: 20px;
}
.cxh:hover .cxhjy {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/productInfo.vue